import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const PANEL_HEIGHT_MIN = 150
const PANEL_HEIGHT_MAX = 900
const PANEL_HEIGHT_DEFAULT = 320

function clampPanelHeight(h: number): number {
  return Math.min(PANEL_HEIGHT_MAX, Math.max(PANEL_HEIGHT_MIN, h))
}

interface DebugPanelState {
  isOpen: boolean
  debugEnabled: boolean
  /** Hauteur du panneau docké en px — persistée entre sessions */
  panelHeight: number
  toggle: () => void
  open: () => void
  close: () => void
  toggleDebug: () => void
  setPanelHeight: (h: number) => void
}

export const useDebugPanelStore = create<DebugPanelState>()(
  persist(
    (set) => ({
      isOpen: false,
      debugEnabled: typeof window !== 'undefined' && localStorage.getItem('MB_DEBUG') === 'true',
      panelHeight: PANEL_HEIGHT_DEFAULT,
      toggle: () => set((s) => ({ isOpen: !s.isOpen })),
      open: () => set({ isOpen: true }),
      close: () => set({ isOpen: false }),
      toggleDebug: () => set((s) => {
        const next = !s.debugEnabled
        localStorage.setItem('MB_DEBUG', String(next))
        return { debugEnabled: next }
      }),
      setPanelHeight: (h) => set({ panelHeight: clampPanelHeight(h) }),
    }),
    {
      name: 'mb-debug-panel',
      partialize: (state) => ({ panelHeight: state.panelHeight }),
    },
  ),
)
